import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';


import * as _ from 'lodash';
import { EndpointFactory } from "./endpoint-factory.service";
import { HttpClient } from "@angular/common/http";
import { ConfigurationService } from "./configuration.service";
import { DocumentTemplate } from "../models/document-template.model";
import { Bookmark } from "../models/bookmakmodel";


@Injectable()
export class DocumentTemplateFormValueService extends EndpointFactory {

    private _baseURl = "";

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }

    saveFormData(documentId: string, formData: any) {
        return this.http
            .post(this._baseURl + `api/documentTemplateFormValue/save-form-data/${documentId}`, formData, this.getRequestHeaders())
            .catch(err => this.handleError(err, null));
    }


    getDocumentTemplateFormData(documentId: number) {
        return this.http
            .get(this._baseURl + `api/documentTemplateFormValue/get-document-form-data/${documentId}`, this.getRequestHeaders())
            .catch(err => this.handleError(err,null))
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/document-template-form-value.service.ts